export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    var dgsButton = document.querySelector('.btn-dgs');
    var otherButton = document.querySelector('.btn-other');

    dgsButton.addEventListener('click', () => { 
      dgsButton.classList.add('btn-secondary')
      dgsButton.classList.add('text-coral')
      dgsButton.classList.remove('btn-white')
      otherButton.classList.remove('btn-secondary')
      otherButton.classList.remove('text-coral')
      otherButton.classList.add('btn-white')

      document.querySelector('.other-courses').style.display = 'none';
      document.querySelector('.dgs-courses').style.display = 'table';
    })

    otherButton.addEventListener('click', () => { 
      otherButton.classList.add('btn-secondary')
      otherButton.classList.add('text-coral')
      otherButton.classList.remove('btn-white')
      dgsButton.classList.remove('btn-secondary')
      dgsButton.classList.remove('text-coral')
      dgsButton.classList.add('btn-white')
      document.querySelector('.other-courses').style.display = 'block';
      document.querySelector('.dgs-courses').style.display = 'none';
    })

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/curriculum.js